import { render } from "./ManagePage.vue?vue&type=template&id=f94539b2&scoped=true"
import script from "./ManagePage.vue?vue&type=script&lang=js"
export * from "./ManagePage.vue?vue&type=script&lang=js"

import "./ManagePage.vue?vue&type=style&index=0&id=f94539b2&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94539b2"]])

export default __exports__